document.querySelectorAll(".newsletter-signup").forEach(holder => {
	const button = holder.querySelector<HTMLButtonElement>(".newsletter-button")!;
	const formDialog = holder.querySelector<HTMLDialogElement>("dialog")!;
	const form = formDialog.querySelector<HTMLFormElement>("form")!;
	const closeBtn = formDialog.querySelector<HTMLButtonElement>(".close-link")!;
	const output = form.querySelector("output")!;

	button.addEventListener("click", () => {
		formDialog.showModal();
	});

	closeBtn.addEventListener("click", () => {
		formDialog.close();
	});

	form.addEventListener("submit", async event => {
		event.preventDefault();

		const submitButton = form.querySelector<HTMLInputElement>('input[type="submit"]');
		if (submitButton) {
			submitButton.value = 'Submitting...'
		}

		const formData = new FormData(form);
		const response = await fetch(
			form.getAttribute("action") ?? "/wp-admin/admin-ajax.php",
			{
				method: form.method,
				body: formData,
			}
		);
		const responseText = await response.text();
		if (submitButton) {
			submitButton.value = 'Sign up'
		}
		output.textContent = responseText;
		output.style.display = "block";
	});
});
